interface SocialIconProps {
  logo: string;
  title: string;
  link: string;
}

export default function SocialIcon({ logo, title, link }: SocialIconProps) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={title}
      className="flex items-center justify-center w-18 h-18 rounded-full bg-white/10 hover:bg-white/20 transition-colors group"
    >
      <img
        src={logo}
        alt={title}
        className="w-10 h-10 object-contain transition-transform duration-300 group-hover:scale-110"
      />
    </a>
  );
}
